/** Progressive enhancements: native Horizon variant/cart behaviour is untouched. */
function initialiseFinder(root) {
  if (root.dataset.mdReady) return;
  root.dataset.mdReady = 'true';
  const results = [...root.querySelectorAll('[data-md-result]')];
  const update = () => {
    const fit = root.querySelector('input[name^="md-fit-"]:checked')?.value;
    const colors = [...root.querySelectorAll('input[name^="md-color-"]')];
    const allowed = new Set(results.filter(result => result.dataset.fit === fit).map(result => result.dataset.color));
    for (const input of colors) input.disabled = !allowed.has(input.value);
    if (!allowed.has(colors.find(input => input.checked)?.value)) {
      const first = colors.find(input => allowed.has(input.value));
      if (first) first.checked = true;
    }
    const color = colors.find(input => input.checked)?.value;
    root.querySelector('[data-md-color-note]').textContent = allowed.size === 1 ? 'Ten fason występuje obecnie w kolorze czarnym.' : '';
    let match = null;
    for (const result of results) {
      const active = result.dataset.color === color && result.dataset.fit === fit;
      result.hidden = !active;
      if (active) match = result;
    }
    root.querySelector('[data-md-empty]').hidden = Boolean(match);
    root.querySelector('[data-md-status]').textContent = match
      ? `Wybrany komplet: ${match.querySelector('h3').textContent.trim()}. Dobierz rozmiary na karcie produktu.`
      : 'Ten zestaw nie jest obecnie prezentowany. Zobacz wszystkie komplety.';
  };
  root.addEventListener('change', update);
  update();
}
const init = () => document.querySelectorAll('[data-md-finder]').forEach(initialiseFinder);
init();
document.addEventListener('shopify:section:load', init);

let sizeGuideTrigger;
document.addEventListener('click', event => {
  const trigger = event.target.closest?.('[data-md-size-guide]');
  const dialog = document.getElementById('md-size-guide');
  if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
  event.preventDefault();
  sizeGuideTrigger = trigger;
  dialog.showModal();
});

/** One session-only, functional dismissal. No email collection, tracking or artificial urgency. */
function madoriaPromotionBlocked() {
  const overlays = document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden]), header-drawer details[open], .header__drawer details[open]');
  const visibleOverlay = [...overlays].some(element => element.getClientRects().length);
  const editing = document.activeElement?.matches('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
  return visibleOverlay || editing || Boolean(document.querySelector('form[data-md-editing], #shopify-pc__banner')?.getBoundingClientRect().height);
}
document.addEventListener('input', event => {
  const form = event.target.closest?.('.md-b2b__form, form[action*="/contact"]');
  if (form) form.dataset.mdEditing = 'true';
});
function initialiseSaleDialog(dialog) {
  if (dialog.dataset.mdReady || typeof dialog.showModal !== 'function') return;
  dialog.dataset.mdReady = 'true';
  const key = 'madoria-sale-dismissed-v2';
  try { if (sessionStorage.getItem(key)) return; } catch { /* Storage may be disabled. */ }
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch { /* Continue without persistence. */ } };
  let previousFocus;
  let timer;
  let attempts = 0;
  const controller = new AbortController();
  const cleanup = () => { clearTimeout(timer); controller.abort(); };
  const show = () => {
    if (!dialog.isConnected) return;
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', show, { once: true, signal: controller.signal });
      return;
    }
    // Do not stack on top of cart/search/size or the privacy choice.
    if (madoriaPromotionBlocked()) {
      if (++attempts < 6) timer = setTimeout(show, 10000);
      return;
    }
    previousFocus = document.activeElement;
    dialog.showModal();
  };
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    remember();
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
  }, { signal: controller.signal });
  dialog.addEventListener('click', event => {
    if (event.target.closest?.('a')) remember();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  }, { signal: controller.signal });
  timer = setTimeout(show, Number(dialog.dataset.delay || 20) * 1000);
  window.addEventListener('pagehide', cleanup, { once: true, signal: controller.signal });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(dialog)) cleanup();
  }, { signal: controller.signal });
}
const initSale = () => document.querySelectorAll('[data-md-sale-dialog]').forEach(initialiseSaleDialog);
initSale();
document.addEventListener('shopify:section:load', initSale);
document.getElementById('md-size-guide')?.addEventListener('close', () => sizeGuideTrigger?.focus());
document.getElementById('md-size-guide')?.addEventListener('click', event => {
  if (event.target === event.currentTarget) {
    const bounds = event.currentTarget.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.currentTarget.close();
  }
});
